import formatArticles from './formatArticles';
import themeEditor from './themeEditor';

export default () => {
  formatArticles();
  themeEditor();
};